// Story time as a year + month fraction (2029.5 = Jul 2029), and back.

export const yearFractionOf = (date: Date) => {
  const year = date.getUTCFullYear()
  const start = Date.UTC(year, 0, 1)
  const next = Date.UTC(year + 1, 0, 1)
  return year + (date.getTime() - start) / (next - start)
}

export const timestampFromYearFraction = (yearFraction: number) => {
  const year = Math.floor(yearFraction)
  const start = Date.UTC(year, 0, 1)
  const next = Date.UTC(year + 1, 0, 1)
  return start + (yearFraction - year) * (next - start)
}
